import { useRef } from 'react'

import * as S from './table.styled'

interface TableCollapsableRowProps {
  isOpen: boolean
  colSpan: number
  children: React.ReactNode
}

export const TableCollapsableRow = ({ isOpen, colSpan, children }: TableCollapsableRowProps) => {
  const contentRef = useRef<HTMLDivElement | null>(null)

  return (
    <S.CollapsableContentRow aria-hidden={!isOpen}>
      <S.CollapsableContentCell $isOpen={isOpen} colSpan={colSpan}>
        <S.CollapsableContentInner
          ref={contentRef}
          style={{ maxHeight: isOpen ? contentRef.current?.scrollHeight : 0 }}
        >
          {children}
        </S.CollapsableContentInner>
      </S.CollapsableContentCell>
    </S.CollapsableContentRow>
  )
}
